<script>
import searchSuggestions from './SearchSuggestionsComponent.vue'

export default {
    extends: searchSuggestions
}
</script>

<style lang="postcss" scoped>
@import 'theme';

.suggestions {
    background: #fff;
    border: 1px solid #e7e9e9;
    border-radius: 5px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
    min-width: 200px;
    overflow: hidden;
    position: absolute;
    right: 0;
    width: 100%;
    z-index: 1;

    & .suggestions__column {
        &:first-child {
            & .suggestions__section:first-child {
                border-top: none;
            }
        }
    }

    & .suggestions__group-heading {
        color: var(--c-accent-text);
        font-size: 16px;
        font-weight: 500;
        margin: 0;
        padding: 8px 16px;

        & .icon {
            display: none;
        }
    }

    & .suggestions__item {
        border-top: 1px solid #e7e9e9;

        &:first-child {
            border-top: none;
        }
    }

    & .suggestions__link {
        color: #5f6367;
        display: block;
        font-weight: var(--fw-light);
        padding: 10px 16px;
        text-decoration: none;

        &.suggestions__link--highlighted,
        &:focus,
        &:hover {
            background: var(--c-dropdown-active-item-bg);
            border-left: 4px solid var(--c-primary);
            color: var(--c-accent-text);
            padding-left: 12px;
        }
    }

    & .suggestions__list {
        border-top: 2px solid #e7e9e9;
        list-style: none;
        margin: 0;
        padding: 0;
    }

    & .suggestions__name {
        font-size: var(--fs-larger);
        line-height: 1.3em;
        margin-bottom: 5px;
    }

    & .suggestions__section {
        border-top: 1px solid #e7e9e9;
    }

    @media (--mq-medium-min) {
        left: 0;
        right: auto;
    }
}
</style>
